import styled from 'styled-components';
import Text from '../../../../../components/Atoms/Text/Text';
import { Icon } from '../../../Header/iconsHelper';
export const StyledAutocompleteItem = styled(Text) `
  padding: 8px 0;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;

  &:before {
    ${({ isActive }) => (isActive ? '' : 'display: none;')}
    content: '';
    position: absolute;
    left: -35px;
    right: -35px;
    top: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colorsV2.ui.background.secondary};
    z-index: -1;
  }

  &:first-of-type {
    margin-top: 8px;
  }
`;
export const AutocompleteIcon = styled(Icon) `
  margin-left: 5px;
`;
export const AutocompleteLabel = styled.span `
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;
export const AutocompleteCategoryLabel = styled.span `
  font-size: 14px;
  line-height: 20px;
`;
export const LastAutocompleteItem = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
//# sourceMappingURL=AutocompleteItem.styled.js.map